import { FicheAutocontroleTab, FicheAutocontroleTabInfos, FicheAutocontroleTabReserves } from "../store/types/FicheAutocontrole.Types";
import { AUTOCONTROLE_STATUT } from "../store/types/generalInformations.Types";

type UpdatePayload =
  | FicheAutocontroleTabInfos
  | FicheAutocontroleTabReserves
  | FicheAutocontroleTab
  | { id_pk: string; id_sk: string; statut: AUTOCONTROLE_STATUT; editBy: string };

export interface PendingUpdate {
  tabToSave: UpdatePayload;
  percentCompletion: number;
  statut?: string;
  timestamp: number;
}

const CACHE_KEY = 'offline_pending_update';
const MAX_CACHE_AGE = 24 * 60 * 60 * 1000; // 24h

export class OfflineCache {

  static save(tabToSave: UpdatePayload, percentCompletion: number, statut?: string) {
    try {
      const pending: PendingUpdate = { tabToSave, percentCompletion, statut, timestamp: Date.now() };
      localStorage.setItem(CACHE_KEY, JSON.stringify(pending));
    } catch (e) {
      console.error('Cache save failed:', e);
    }
  }

  static load(): PendingUpdate | null {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const pending: PendingUpdate = JSON.parse(raw);
      if (Date.now() - pending.timestamp > MAX_CACHE_AGE) {
        this.clear();
        return null;
      }
      return pending;
    } catch (e) {
      console.error('Cache load failed:', e);
      return null;
    }
  }

  static clear() {
    localStorage.removeItem(CACHE_KEY);
  }

  static hasPendingData(): boolean {
    return this.load() !== null;
  }
}
